/**
 * A diff cut at its hunk headers, for per-hunk Revert in the Changes tab.
 *
 * The cut is the same one core's `splitHunks` makes — every `@@ -` line starts
 * a hunk — so hunk N here names hunk N on the server (`changes.rejectHunk`).
 * The desktop renderer's `diffSections` makes the same cut; a test pins all
 * three together.
 */
export function diffSections(diff: string): { head: string[]; hunks: string[][] } {
  const head: string[] = [];
  const hunks: string[][] = [];
  for (const line of diff.split("\n")) {
    if (/^@@ -\d/.test(line)) hunks.push([line]);
    else if (hunks.length === 0) head.push(line);
    else hunks[hunks.length - 1]!.push(line);
  }
  return { head, hunks };
}
